
import usPhoneNumberFormatter from "./format-us-phone";

$(function() {
  $('.phone-number').on('input', function() {
      const number = usPhoneNumberFormatter($(this).val());
      $(this).val(number.formatted);
  });
});
